import { IContact } from 'common/interfaces/contacts';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';

// Styles
const s = require('./../LeadContacts.css');
const iconPrimary = require('assets/primary icon.svg');
const iconSecondary = require('assets/contact icon.svg');

// Interfaces
interface IContactMean {
  key: string;
  label: string;
  value: string;
}

// Props
interface ILeadContactViewProps {
  contact?: IContact;
}

// Component
@observer
export class LeadContactView extends React.Component<
  ILeadContactViewProps,
  {}
> {
  constructor(props: ILeadContactViewProps) {
    super(props);
  }

  @computed private get fullName(): string {
    const { contact } = this.props;
    const str = [
      contact.firstName || null,
      contact.middleName || null,
      contact.lastName || null,
    ].join(' ');
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  @computed private get title(): string {
    const { contact } = this.props;
    return contact.title
      ? contact.title.charAt(0).toUpperCase() + contact.title.slice(1)
      : '';
  }

  private OFFICE_PHONE_LABEL = 'P.';
  private MOBILE_PHONE_LABEL = 'M.';
  private FAX_LABEL = 'F.';
  private EMAIL_LABEL = 'E.';

  @computed private get contactMeans(): IContactMean[] {
    const { contact } = this.props;
    const means: IContactMean[] = [];

    if (contact.officePhone) {
      means.push({
        key: 'office-phone',
        label: this.OFFICE_PHONE_LABEL,
        value: contact.officePhone,
      });
    }

    if (contact.mobilePhone) {
      means.push({
        key: 'mobile-phone',
        label: this.MOBILE_PHONE_LABEL,
        value: contact.mobilePhone,
      });
    }

    if (contact.fax) {
      means.push({
        key: 'fax-number',
        label: this.FAX_LABEL,
        value: contact.fax,
      });
    }

    return means;
  }

  public render() {
    const { contact } = this.props;

    return (
      <div className={s.contact}>
        <div className={s.name}>
          <h1>{this.fullName}</h1>
        </div>

        {this.title && (
          <div className={s.title}>
            <h2>{this.title}</h2>
          </div>
        )}

        {(this.contactMeans.length > 0 || contact.emailAddress) && (
          <ul className={s.means}>
            {this.contactMeans.map((mean) => (
              <li key={mean.key}>
                {([this.MOBILE_PHONE_LABEL, this.OFFICE_PHONE_LABEL].indexOf(
                  mean.label
                ) === 0 && (
                  <a href={`tel:+1 ${mean.value.replace(/ /g, '')}`}>
                    {`${mean.label} ${mean.value}`}
                  </a>
                )) || <p>{`${mean.label} ${mean.value}`}</p>}
              </li>
            ))}

            {contact.emailAddress && (
              <li key="email-address">
                <p className={s.contactEmailAddress}>
                  <a
                    title={contact.emailAddress}
                    href={`mailto:${contact.emailAddress}`}
                  >
                    {this.EMAIL_LABEL + ' ' + contact.emailAddress}
                  </a>
                </p>
              </li>
            )}
          </ul>
        )}

        <img
          className={s.icon}
          src={contact.default ? iconPrimary : iconSecondary}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/Contacts/Contact/LeadContactView.tsx